
import {forkJoin as observableForkJoin,  Observable } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { FooterConfigService } from 'app/homepage-configuration/footer-config/footer-config.service';
import { FooterCellListResource } from 'app/models/FooterCellListResource';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NotificationsService } from 'angular2-notifications';
import { FooterCopyRightResource } from 'app/models/FooterCopyRightResource';
import { Validators, FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { DragulaService } from "ng2-dragula";
import { FooterBarLinkListResource } from 'app/models/FooterBarLinkListResource';
import { FooterBarLinkResource } from 'app/models/FooterBarLinkResource';
import { FooterColumnShiftComponent } from "app/homepage-configuration/footer-config/footer-column-shift/footer-column-shift.component";

@Component({
  selector: 'vbn-footer-config',
  providers: [FooterConfigService, FooterColumnShiftComponent ],
  templateUrl: './footer-config.component.html',
  styleUrls: ['./footer-config.component.scss']
})
export class FooterConfigComponent implements OnInit {

  footerCellListResource: FooterCellListResource;
  footerCopyRightResource: FooterCopyRightResource;
  errorMessage: any;
  columnShift: boolean = false;
  // dragulaDrop: any;
  showShiftBtn: boolean = false;
  footerCellListResourceActive: FooterCellListResource;
  user = localStorage.getItem("_user");


  constructor(private shiftComponent: FooterColumnShiftComponent, private footerConfigService: FooterConfigService, private router: Router, private translate: TranslateService, private _notificationService: NotificationsService) {
    this.footerCellListResource = new FooterCellListResource();
    this.footerCopyRightResource = new FooterCopyRightResource();
    this.footerCellListResourceActive = new FooterCellListResource();
  }


  ngOnInit() {
    this.getFooterCellListComponent();
    this.getAllFooterCellActive()
  }

  getAllFooterCellActive() {
    this.footerConfigService.getCellActive('/admin/footer/cell/getActive?email=' + this.user)
      .subscribe(
      body => {
        this.footerCellListResourceActive = body;
        if(this.footerCellListResourceActive != null){
          if(this.footerCellListResourceActive.footerCellListResource != null){
            let count = this.footerCellListResourceActive.footerCellListResource.length;
            if(count>=2){
              this.showShiftBtn = true;
            }  else {
              this.showShiftBtn = false;
            }
          }
        }
      },
      error => this.errorMessage = <any>error)
  }

  getFooterCellListComponent() {
    this.footerConfigService.getFooterCellList('/admin/footer/cell/getAllAdmin?email=' + this.user)
      .subscribe(
        response => {
          this.footerCellListResource = response;
          console.log("footerCellListResource: ", this.footerCellListResource)
        },
        error => this.errorMessage = <any>error
      );
  }

  goToEdit(rid: number) {
    this.router.navigate(['/edit-column/' + btoa('{ "rid" : "' + rid + '"}')]);
  }

  deleteFooterCell(rid: number) {
    this.footerConfigService.deleteFooterCell('/admin/footer/cell/delete/' + rid)
      .subscribe(
        response => {
          observableForkJoin(
            this.translate.get('Success'),
            this.translate.get('The column has been successfully deleted!')
          ).subscribe((res) => {
            this._notificationService.create(res[0], res[1], 'success')
          })
          this.getFooterCellListComponent();
          this.getAllFooterCellActive();
        },
        error => this.errorMessage = <any>error
      );
  }

  delete(elem) {
    elem.showDelete = true;
  }
  // getActiveCellsButton() {
  //   this.columnShift = true;
  //   this.getAllFooterCellActive();
  // }

  // showFooterText() {
  //   this.footerCopyright = true;
  //   this.getFooterText();
  // }

  cancel() {
    //this.footerCopyright = false;
    this.footerCopyRightResource = new FooterCopyRightResource();
  }
}
